import { CallToAction, Container, Description, Title } from './PromoCard.style';

type Props = {
  title: string;
  description: string;
  callToAction: {
    label: string;
    url: string;
    target?: string;
    altText?: string;
  };
};

export const PromoCard = ({ title, description, callToAction }: Props) => {
  return (
    <Container>
      <Title>{title}</Title>
      <Description>{description}</Description>
      {/* //add target */}
      <CallToAction variant="darkBg" href={callToAction.url}>
        {callToAction.label}{' '}
      </CallToAction>
    </Container>
  );
};
